export const state = {
  projectsFolderToRename: {},
  projectsFolderRenameDialogIsOpen: false,
  projectsFolderRenamePending: false,
}
